import React from 'react'
import { Link } from 'react-router-dom'

export const DynamicLink = ({ isActive = true, children, ...rest }) => {
  return isActive ? (
    <Link {...rest}>{children}</Link>
  ) : (
    <span {...rest}>{children}</span>
  )
}

export default DynamicLink
